import styled from 'styled-components';

interface UploadBtnProps {
    $isDragActive: boolean;
    $checkExtension: boolean;
    $hasFiles: boolean;
    $disabled: boolean;
    $failure: boolean;
}
export const UploadBtn = styled.div<UploadBtnProps>`
    &:hover {
        cursor: pointer;
    }

    u {
        margin-top: 12px;
        text-decoration: none;
        color: var(--vivid-pink);
    }

    h4 {
        font-size: 12px;
        line-height: 16px;
        color: var(--black);
        width: 194px;

        span {
            font-size: 10px;
            color: var(--cadetGrey);

        }
    }
    ${(props) => props.$disabled && `
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none; 
        background-color: var(--sidebar-hover);
        border-color: var(--disabled-bg);
    `}

    position: relative;
    font-family: "Mulish", sans-serif;

    background-image: ${({ $isDragActive }) =>
         ($isDragActive ? 
        `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%231860D9FF' stroke-width='2' stroke-dasharray='7%2c 8' stroke-dashoffset='20' stroke-linecap='square'/%3e%3c/svg%3e")` : 
        `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%238D9BB8FF' stroke-width='2' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`)};
        
    background-color: ${({ $isDragActive }) => ($isDragActive ? `var(--white)` : `var(--background)`)};

background-image: ${({ $isDragActive, $failure }) => {
        const isError = $failure;
        const strokeColor = isError ? '%23FF4D4F' : ($isDragActive ? '%231860D9' : '%238D9BB8');
        
        return `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='${strokeColor}' stroke-width='2' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`;
    }};



    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;

    label {
        position: absolute;
        bottom: 10px;

        u {
            text-decoration: none;
        }
    }

    width: 100%;
    height: 234px;
    display: inline-flex;
    border-radius: 10px;
    margin-bottom: 20px;

    @media (max-width: 767px) {
        margin-bottom: 15px;
        height: 234px;
        h4 {
            color: ${(props) => (props.$disabled  ? `var(--black)` : `var(--apple)`)};
        }
    }
`;
